import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { useErrands } from '@/api/hooks/useErrands'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import { EmptyState } from '@/components/molecules/empty-state'
import PageHeader from '@/components/molecules/page-header'
import { PlayVideoButton } from '@/components/molecules/play-video-button'
import { CreateErrandDialog } from '@/components/organisms/create-errand-dialog'
import ErrandsTable from '@/components/organisms/errands-table'
import { ERRANDS_VIDEO } from '@/config/videos'
import { useIndividuals } from '@/hooks/useIndividuals'

const ErrandsPage = () => {
  const { individualQuery, selectedIndividualId } = useIndividuals()
  const { t } = useTranslation()
  const { data: errands = [] } = useErrands(selectedIndividualId)

  return (
    <div className="space-y-8 z-10">
      <PageHeader
        body={t('errandsPage.header.description')}
        heading={t('errandsPage.header.title')}
        titleAction={
          <PlayVideoButton titleKey={ERRANDS_VIDEO.titleKey} youtubeId={ERRANDS_VIDEO.youtubeId} />
        }
      >
        <CreateErrandDialog />
      </PageHeader>
      <StateSwitcher
        emptyState={
          <EmptyState
            body={t('errandsPage.emptyState.description')}
            ctaType="create-content"
            heading={t('errandsPage.emptyState.title')}
          />
        }
        isEmpty={errands.length === 0}
        isLoading={individualQuery.isLoading}
      >
        <ErrandsTable errands={errands} />
      </StateSwitcher>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/errands/')({
  component: ErrandsPage,
})
